'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('./index-fccd5f88.js');
var Button = require('./Button-ef2d53dd.js');
var injectGlobalCss = require('./injectGlobalCss-bc8cf911.js');
require('./Icons-46f5553f.js');
require('./Loader-ba47a627.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var css = ".SkipToMainContent_module_Skip__778b9c56 {\n  position: absolute;\n  left: -10000px;\n  top: auto;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  transition-property: all;\n}\n.SkipToMainContent_module_Skip__778b9c56:focus-visible {\n  position: fixed;\n  width: auto;\n  height: auto;\n  left: 210px;\n  top: 12px;\n  z-index: 9999;\n  transition-property: all;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}";
injectGlobalCss.injectCss(css, "/opt/atlassian/pipelines/agent/build/src/stories/components/Molecules/SkipToMainContent/SkipToMainContent.module.scss");
var modules_4244a4e1 = {"Skip":"SkipToMainContent_module_Skip__778b9c56"};

function SkipToMainContent(_ref) {
  var label = _ref.label,
    sectionTarget = _ref.sectionTarget,
    action = _ref.action;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(Button.ButtonLink, {
    href: '#' + sectionTarget + '',
    extraClass: modules_4244a4e1.Skip,
    label: label,
    action: action ? action : null
  }));
}
SkipToMainContent.propTypes = {
  label: index.propTypes.exports.string.isRequired,
  sectionTarget: index.propTypes.exports.string,
  action: index.propTypes.exports.func
};

exports.SkipToMainContent = SkipToMainContent;
